<style lang="less">
	video{
		max-width: 100% !important;
		background-repeat: no-repeat;
		margin-right: auto;
		margin-right: auto;
	}

 </style>

 <template>
	<v-row v-if="user">
		<v-col>
			<v-card v-if="appointment">


				<v-stepper v-model="stepValue" vertical >
					<v-stepper-step step="1">
						Welcome
					</v-stepper-step>

					<v-stepper-content step="1">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<p>This tool is intended to test your browser, microphone and speakers in preparation for a video appointment.</p>
							<p>To get started, click 'continue'</p>
						</v-card>
						<v-btn color="primary" @click="startTest">Continue</v-btn>
						<v-btn text @click="cancel">Cancel</v-btn>
					</v-stepper-content>

					<v-stepper-step step="2">Connect to video</v-stepper-step>

					<v-stepper-content step="2">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<p>{{message}}</p>
							
							<v-alert dense v-if="videoConnected" color="white" >
								<v-checkbox :value="true" v-model="confirmedVideo" label="I can see myself in the video stream to the right"></v-checkbox>
							</v-alert>
							<p v-if="videoConnected">We'd like to ask you a couple of questions to test the recording quality</p>
							<p v-if="videoConnected">Click 'continue'</p>
						</v-card>
						<v-btn color="primary" :disabled="!confirmedVideo" @click="stepValue = 3">Continue</v-btn>
						<v-btn text @click="cancel">Cancel</v-btn>
					</v-stepper-content>

					<v-stepper-step step="3">Answer questions</v-stepper-step>
					<v-stepper-content step="3">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<div v-if="project">
								<p>Please answer the following aloud: </p>
								<v-alert dense color="white" border-color="grey"  v-for="(question, i) in project.rescreeningQuestions" :key="i" class="mb-2">
									{{question}}
								</v-alert>
							</div>
						</v-card>
						<v-btn color="primary" @click="getRecording">Continue</v-btn>
						<v-btn text @click="cancel">Cancel</v-btn>
					</v-stepper-content>

					<v-stepper-step step="4">Confirm Audio</v-stepper-step>
					<v-stepper-content step="4">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<div v-if="!audioUrl">
								{{message}}	
								<v-progress-linear indeterminate></v-progress-linear>
							</div>
							<div v-else>
								<p> Please listen to the audio. </p>
								<audio controls :src="audioUrl">
									Your browser does not support the
									<code>audio</code> element.
								</audio>
									<v-alert  color="white" dense>
										<v-checkbox :value="true" v-model="confirmedAudio" label="I have listened to the audio and I can hear my own answers clearly"></v-checkbox>
									</v-alert>
							</div>
						</v-card>
						<v-btn color="primary" @click="stepValue = 5" :disabled="!confirmedAudio">Continue</v-btn>
						<v-btn text @click="cancel">Cancel</v-btn>
					</v-stepper-content>

					<v-stepper-step step="5">Complete Test</v-stepper-step>
					<v-stepper-content step="5">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<p>Thank you for taking the time to run this test.</p>
							<p v-if="appointment">We look forward to speaking with you at: {{ appointment.dateTime.toDate() | moment("HH:mm on dddd D/MM/YYYY") }}</p>
							
						</v-card>
						<v-btn color="primary" @click="endTest">End Test</v-btn>
						<v-btn text @click="cancel">Cancel</v-btn>
					</v-stepper-content>
				</v-stepper>
			</v-card>
			<v-card v-else class="pa-4">
				Appointment not found, please contact Meisterworks
			</v-card>
		</v-col>
		<v-col>
			<div v-if="testStarted" width="100%">
				<div id="participantStream" v-if="!videoComplete"></div>
			</div>
		</v-col>
	</v-row>
</template>

<script>
	import Vuex from "vuex";
	import Twilio, { connect, createLocalTracks, createLocalVideoTrack, LocalVideoTrack } from 'twilio-video';
	createLocalVideoTrack;
	LocalVideoTrack;
	createLocalTracks;
	connect;
	Twilio;
	import axios from 'axios'
	export default {
		name: "VideoTest",
		props: {
			"id": {type: String}, 
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user, 
				appointments: state => state.panelmember ? state.panelmember.appointments : [],
				projects: state => state.panelmember ? state.panelmember.projects : [],
			}),
			appointment(){
				var aid = this.id;
				return this.appointments.find( a => a.id == aid)
			},
			project(){
				if( !this.appointment ){
					return;
				}
				var pid = this.appointment.project;
				return this.projects.find( p => p.id == pid)
			},
			roomIdentity(){
				return this.id + "-Test"
			}, 
			session(){
				return {
					appointment: this.id,
					user: this.user.uid,
				}
			},
		},
		data: () => {
			return {
				testStarted: false,
				sessionId: false,
				activeRoom: false, 
				videoConnected: false,
				videoComplete: false,
				networkQuality: false,
				roomSid: false,
				message: "Connecting...",
				stepValue: 1, 
				audioUrl: false,
				confirmedAudio: false,
				confirmedVideo: false
			}
		},
		methods: {
			async getAccessToken() {
				var session = this.sessionId;
				return await axios.get(`https://x.m.works:1880/twilio/videoTest/${session}`)
			},
			async generateRecording() {
				var session = this.sessionId;
				return await axios.get(`https://x.m.works:1880/twilio/getTestRecording/${session}`)
			},
			startTest(){
				const self = this;
				self.testStarted = true;
				this.$store.dispatch("addDoc", {
					collection: "videoTests", 
					data: self.session
				}).then( (ref) => {
					self.stepValue = 2;
					self.sessionId = ref.id;
				})

			},
			endTest(){					
				const self = this;
				self.$emit("complete");
				// self.$router.push( "/" )
				
			},
			startVideo(){
				const self = this;
				self.getAccessToken().then( (data) => { 
					const token = data.data.response;
					let connectOptions = {
						name: self.roomIdentity,
						audio: true,
						video: true,
						networkQuality: {
							local: 3
						},
						RecordParticipantsOnConnect: true
					};

					Twilio.connect(token, connectOptions).then(function(room) {
						self.activeRoom = room;
						self.roomSid = room.sid;
						self.newLocalParticipant();
						room.on('disconnected', function() {
							self.endVideo();
						});

					}).catch(  () => {
						self.message = "Token mismatch. Please contact Meisterworks"
					})

				}).catch( () => {
					self.message = "Test failed. Please contact Meisterworks"
				})
			},
			endVideo(){
				const self = this;
				self.networkQuality = self.activeRoom.localParticipant.networkQualityLevel;
				self.activeRoom.disconnect();
				self.activeRoom = null;
				self.videoComplete = true;
				var doc = "videoTests/" + self.sessionId;
				self.$store.dispatch("updateDoc", {
					doc: doc, 
					data: {
						videoConnected: self.videoConnected,
						videoComplete: self.videoComplete,
						networkQuality: self.networkQuality,
					},
					action: "update"
				})
			},
			getRecording(){
				const self = this;
				self.endVideo();
				self.stepValue = 4;
				self.message = "Generating recordings";
				self.generateRecording().then( (response) => { 
					self.audioUrl = response.data;
					// if( response.data ){
					// 	self.stepValue = 5;
					// }
				});
			},
			newLocalParticipant(){
				const self = this;
				let tracks = self.getParticipantTracks(self.activeRoom.localParticipant); 
				tracks.forEach( track => self.addSingleTrackToCall( track ))
				self.videoConnected = true;

			},
			getParticipantTracks(participant) {
				return Array.from(participant.tracks.values()).filter(function(publication) {
					return publication.track;
				}).map(function(publication) {
					return publication.track;
				});
			},
			addSingleTrackToCall(track){
				let wrapper = document.getElementById("participantStream");
				if( !wrapper ){ return  }
				wrapper.appendChild(track.attach())
			},
		},
		watch: {
			roomSid(){
				if( this.roomSid ){
					var sid = this.roomSid;
					var doc = "videoTests/" + this.sessionId;
					this.$store.dispatch("updateDoc", {
						doc: doc, 
						data: {roomSid: sid },
						action: "update"
					})
				}
			},
			sessionId(){
				if( this.sessionId ){
					this.startVideo();
				}
			},
			videoConnected(){
				this.message = "Video Connected";
			},
			appointment(){
				if( this.appointment ){
					this.$store.dispatch( 'fetchProject', this.appointment.project );
				}
			},
			view: function(nv){
				if( nv !== 'panelmember' ){
					this.$router.replace({ name: "home" });
				}
				this.$store.dispatch( 'fetchAppointments' );
			},
			confirmedAudio(){
				if( this.confirmedAudio ){
					var doc = "videoTests/" + this.sessionId;
					this.$store.dispatch("updateDoc", {
						doc: doc, 
						data: {confirmedAudio: true },
						action: "update"
					})
				}
			},
			confirmedVideo(){
				if( this.confirmedVideo ){
					var doc = "videoTests/" + this.sessionId;
					this.$store.dispatch("updateDoc", {
						doc: doc, 
						data: {confirmedVideo: true },
						action: "update"
					})
				}
			},
		}
	}
</script>